/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import InspectionRecordReport from "./InspectionRecordReport";

export default function InspectionRecordReportPage() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const tt = (key: string, options?: Record<string, unknown>) => t(key, { ns: "translation", ...options });

    const from = (location.state as any)?.from as string | undefined;

    const handleBack = () => {
        if (from) {
            navigate(from, { replace: true });
            return;
        }
        navigate(-1);
    };

    if (!id) {
        return (
            <div className="p-3">
                <p>{tt("pages.thermography.inspectionRecordReportPage.notFound")}</p>
                <Button variant="outline-primary" onClick={handleBack}>
                    {tt("pages.thermography.inspectionRecordReportPage.back")}
                </Button>
            </div>
        );
    }

    return (
        <div>
            <div className="d-print-none p-2 d-flex gap-2 justify-content-end">
                <Button variant="outline-primary" onClick={handleBack}>
                    {tt("pages.thermography.inspectionRecordReportPage.back")}
                </Button>

                <Button variant="primary" onClick={() => window.print()}>
                    {tt("pages.thermography.inspectionRecordReportPage.print")}
                </Button>
            </div>

            <InspectionRecordReport />
        </div>
    );
}
